export const CUSTOM_COLORS = {
  D2D3D7: '#D2D3D7',
  F77171: '#f77171',
  UP: '#00dfa2',
  DEGRADED: '#ffb84c',
  DOWN: '#ff0060',
  LOADING: '#a6a7b0',
  LIGHT_GREYISH: '#1C1B1F',
  DANGER_BG: '#FBEAEA',
  SUCCESS_BG: '#00a3311a',
  INFO_BG: '#e8f7fd',
  FFBAF8: '#FFBAF8',
  F99BAB: '#F99BAB',
  CB3232: '#CB3232',
  F79E1B: '#F79E1B',
  F1BF39: '#F1BF39',
  '078B47': '#078B47',
  '9BDFC4': '#9BDFC4',
  '91C43E': '#91C43E',
  '01A3FF': '#01A3FF',
  '265AE0': '#265AE0',
  '6A6EF4': '#6A6EF4',
  '0557D0': '#0557D0',
  DE6CA2: '#DE6CA2',
  AF59E5: '#AF59E5',
  ACTIVE: '#00A331',
  INACTIVE: '#D92C2C',
  UNKNOWN: '#2B2D42',
  INDRAFTS: '#D68309',
  '6A4EDE': '#6A4EDE',
  b8acff: '#b8acff',
  '847f8d': '#847f8d',
  SUCCESS_RATE: '#5EDA83',
  ERROR_RATE: '#FF1654',
  PAYMENTS_ERROR_RATE: '#00b3ff',
  PAYMENTS_UPTIME: '#7F00FF',
  DECLINE_RATE: '#000',
  F3F3F3: '#F3F3F3',
  BLUE_VARIANT: '#023579',
  F8F8F8: '#F8F8F8',
  FFF8EE: '#fff8ee',
  FDBA57: '#fdba57',
  PRIMARY_8457e5: '#8457e5',
  '00B7B1': '#00B7B1',
  DARK_PRIMARY_C4B6EE: '#C4B6EE',
  DANGER_FF6B6B: '#FF6B6B',
  PRIMARY_6930ca: '#6930ca',
  DANGER_e33d48: '#e33d48',
  PRIMARY_6d2fda: '#6d2fda',
  '797979': '#797979',
  SECONDARY_6B6C7B: '#6B6C7B',
  WHITE_0000000D: '#0000000D',
  ORANGE_FBF3E6: '#FBF3E6',
  GREEN_388023: '#388023',
  PURPLE_6A31CB: '#6A31CB',
  GRAY_E6E5E8: '#E6E5E8',
  MUTED_BLUE: '#2b2d42',
  PRIMARY_F3EDF999: '#f3edf999',
  AEABAB: '#aeabab',
  WHITE: '#ffffff',
  FOFOFO: '#f0f0f0',
  D9D9D9: '#d9d9d9',
  E5E7EB: '#e5e7eb',
  F3E8FF: '#f3e8ff',
  E0E0E0: '#e0e0e0',
  E6E9EE: '#e6e9ee',
  COLOR_4CAF50: '#4CAF50',
  E0DAF3: '#E0DAF3',
  FEF5E7: '#fef5e7',
  FF9500: '#ff9500',
  FAF6FF: '#FAF6FF',
  COLOR_6B46C1: '#6b46c1',
  EEE6FF: '#eee6ff',
  D1C4E9: '#d1c4e9',
  EBE4F9: '#ebe4f9',
};
